import React from 'react';

import { MenuItem, ListItemText, Paper } from '@ha/dsl';
import {
  SuggestionArgs,
  RenderInputFn,
  RenderMenuArgs,
  AutocompleteTextInput,
} from './Autocomplete';

export interface SimpleItem {
  id: string;
  label: string;
  disabled?: boolean;
  placeId?: string;
}

// investigation needed for improving this functions using theme
// https://housinganywhere.atlassian.net/browse/HA-2573
function renderSuggestion({
  item,
  highlighted,
  value,
  props,
}: SuggestionArgs<SimpleItem>): React.ReactNode {
  const isSelected = value === item.label;

  return (
    <MenuItem
      key={item.id}
      selected={highlighted}
      disabled={item.disabled}
      style={{ fontWeight: isSelected ? 500 : 400 }}
      {...props}
    >
      <ListItemText>{item.label}</ListItemText>
    </MenuItem>
  );
}

function renderMenu({ key, children }: RenderMenuArgs): React.ReactNode {
  return (
    <Paper
      data-test-locator="Location - auto-suggest"
      key={key}
      square
      style={{ position: 'absolute', zIndex: 1, left: 0, right: 0 }}
    >
      {children}
    </Paper>
  );
}

function getItemValue(item: SimpleItem) {
  return item.label;
}

interface RequiredProps {
  onChange: (value: string) => void;
  onSelect: (value: string, item: SimpleItem) => void;
  renderInput: RenderInputFn;
  items: SimpleItem[];
}

interface DefaultProps {
  value?: string;
}

type Props = RequiredProps & DefaultProps;

// This component is accepting a renderInput fn
// The main purpose of this component is to define a ui about
// how to render MENU for the particular managing of locations
// We accept a facc for the input because it usually needs to be controlled
// by something else, i.e: redux form field, formik, etc., which usually they
// need to pass specific props for errors, warnings, etc.
export const LocationAutocompleteInput: React.FC<Props> = ({
  onChange,
  onSelect,
  items,
  renderInput,
  value = '',
}) => (
  <AutocompleteTextInput
    value={value}
    items={items}
    onChange={onChange}
    onSelect={onSelect}
    renderInput={renderInput}
    renderSuggestion={renderSuggestion}
    renderMenu={renderMenu}
    getItemValue={getItemValue}
    selectOnBlur={false}
  />
);
